import {
    ODataHeader,
    ODataString,
    ODataDate,
    ODataDecimal,
    ODataEnum,
    ODataDateTime
} from "pbas-vue-components";
import { translate2 } from '../trans2'
import { i18n } from '@/plugins/i18n';
import store from '@/store'

const CoverageConfigurationHistoryHeaders = [
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        visible: false,
        isIdentifier: true,
        allowVisibilityChange: false,
        searchable: false,
        version: 1
    }),
    new ODataHeader({
        type: new ODataString("ConfigurationParameter/Translations[]/LanguageCode"),
        sortable: false,
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
    }),
    new ODataHeader({
        title: "globals.description",
        type: new ODataString("ConfigurationParameter/Translations[]/Description", {
            getString: (item) => translate2(item.ConfigurationParameter, "Description")
        }),
        sortable: true,
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        version: 1,
        orderByKey: "ConfigurationParameter/Description"
    }),
    new ODataHeader({
        title: "globals.description",
        type: new ODataString("ConfigurationParameter/Description"),
        sortable: true,
        visible: false,
        searchable: true,
        allowVisibilityChange: false,
        version: 1
    }),
    // new ODataHeader({
    //     title: "globals.description",
    //     type: new ODataString("ConfigurationParameter/Description"),
    //     sortable: true,
    //     visible: true,
    //     searchable: true
    // }),
    // new ODataHeader({
    //     title: "headers.coverage_configuration.type_description",
    //     type: new ODataString("ConfigurationParameter/TypeDescription"),
    //     sortable: true,
    //     visible: false,
    //     searchable: true,
    //     allowVisibilityChange: false,
    //     version: 2
    // }),
    // new ODataHeader({
    //     title: "headers.coverage_configuration.type_description",
    //     type: new ODataString("ConfigurationParameter/ParameterType", {
    //         getString: (item) => i18n.t("enums."+item.ConfigurationParameter.ParameterType)
    //     }),
    //     sortable: true,
    //     visible: true,
    //     searchable: true,
    //     allowVisibilityChange: true,
    //     version: 3
    // }),
    new ODataHeader({
        title: "headers.coverage_configuration.type_description",
        type: new ODataEnum("ConfigurationParameter/ParameterType", {
          getString: (item) => i18n.t("enums." + item.ConfigurationParameter.ParameterType),
          dropdownItems: store.getters['plansMembers/options']?store.getters['plansMembers/options'].Enums.ParameterType:[]
        }),
        sortable: true,
        visible: true,
        searchable: true,
        allowVisibilityChange: true,
        version: 3,
      }),
    // new ODataHeader({
    //     title: "headers.coverage_configuration.type_description",
    //     type: new ODataString("ConfigurationParameter/Translations[]/TypeDescription", {
    //         getString: (item) => translate2(item.ConfigurationParameter, "TypeDescription")
    //     }),
    //     sortable: true,
    //     visible: true,
    //     allowVisibilityChange: true,
    //     searchable: true,
    //     version: 2,
    //     orderByKey: "ConfigurationParameter/TypeDescription"
    // }),
    new ODataHeader({
        title: "globals.value",
        type: new ODataDecimal("Value", {
            getString: (item, type) => {
                const v = item.Value;
                if (
                    item.ConfigurationParameter.ParameterType === "Amount"
                ) {
                    const formatter = new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2
                    });
                    return formatter.format(v);
                } else if (item.ConfigurationParameter.ParameterType === "Percentage") {
                    return (parseFloat(v) * 100).toFixed(2) + "%";
                } /* else if (item.ParameterType === "Constant") {} */
                else {
                    return v;
                }
            }
        }),
        sortable: false,
        visible: true,
        searchable: false
    }),
    new ODataHeader({
        title: "globals.coverage",
        type: new ODataString("Coverage/Translations[]/Name", {
            getString: (item) => {
                //console.log(item); 
                return translate2(item.Coverage, "Name")}
        }),
        sortable: true,
        visible: true,
        allowVisibilityChange: true,
        searchable: true,
        orderByKey:"Coverage/Name"
    }),
    new ODataHeader({
      title: "components.plancreationwizard.contribution_category",
      type: new ODataString("ConfigurationParameter/Identity/ContributionCategory"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
        title: "headers.members_management.Employer",
        type: new ODataString(
          "ConfigurationParameter/Identity/Employer/Current/Translations[]/Name",
          {
            getString: (item) => {
              if (
                !item ||
                !item.ConfigurationParameter ||
                !item.ConfigurationParameter.Identity ||
                !item.ConfigurationParameter.Identity.Employer ||
                !item.ConfigurationParameter.Identity.Employer.Current
              )
                return "";
              return translate2(
                item.ConfigurationParameter.Identity.Employer.Current,
                "Name"
              );
            },
          }
        ),
      }),
      new ODataHeader({
        title:"Employer/Translations[]/LanguageCode",
        type: new ODataString(
          "ConfigurationParameter/Identity/Employer/Current/Translations[]/LanguageCode"
        ),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title:"Employer/Name",
        type: new ODataString(
          "ConfigurationParameter/Identity/Employer/Current/Name"
        ),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "globals.store",
        type: new ODataString(
          "ConfigurationParameter/Identity/Store/Current/Translations[]/Name",
          {
            getString: (item) =>{
            if (
              !item ||
              !item.ConfigurationParameter ||
              !item.ConfigurationParameter.Identity ||
              !item.ConfigurationParameter.Identity.Store ||
              !item.ConfigurationParameter.Identity.Store.Current
            )
              return "";
              return translate2(item.ConfigurationParameter.Identity.Store.Current, "Name")
              },
            getHtml: (item, type) => {
              return (
                "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
                type.getString(item, type) +
                "</div>"
              );
            },
          }
        ),
        sortable: true,
        visible: true,
        searchable: true,
        // orderByKey: "CurrentEmploymentInformation/Store/Current/Name",
      }),
      new ODataHeader({
        title:"Store/Translations[]/LanguageCode",
        type: new ODataString(
          "ConfigurationParameter/Identity/Store/Current/Translations[]/LanguageCode"
        ),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title:"Store/Name",
        type: new ODataString(
          "ConfigurationParameter/Identity/Store/Current/Name"
        ),
        visible: false,
        allowVisibilityChange: false,
        searchable: false,
      }),
      new ODataHeader({
        title: "views.coverage.funded_percentage",
        type: new ODataDecimal("FundedPercentage", {
          getString: (item, type) => {
            let v = item.FundedPercentage;
            if (!v) {
              return "";
            }
            return (parseFloat(v) * 100).toFixed(2) + "%";
          },
        }),
        sortable: true,
        visible: true,
        searchable: true,
      }),
      new ODataHeader({
        title: "components.inmemorydependants.effective_date",
        type: new ODataDate("EffectiveDate"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
      title: "headers.pension_regulators.user",
      type: new ODataString("User"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.pension_regulators.activity",
      type: new ODataString("Activity", {
        getString: (item) => i18n.t("enums." + item.Activity),
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
    }),
];
export default CoverageConfigurationHistoryHeaders;